/* eslint-disable @typescript-eslint/no-empty-function */
// use this link to require signed in (persisted / dataRedacted) user to re-authenticate
'use client';

import { ComponentProps } from 'react';

import { RE_AUTH_ROUTE } from '@fshr/auth';
import { useRouter } from 'next/navigation';
import { useLocaleLink } from '@fshr/context/i18n-context';

import Link from '../link';

interface LinkIfFullyAuthenticatedProps extends ComponentProps<typeof Link> {
	isFullyAuthenticated: boolean;
}

export default function LinkIfFullyAuthenticated({
	href,
	isFullyAuthenticated,
	onClick = () => {},
	...props
}: LinkIfFullyAuthenticatedProps) {
	const router = useRouter();
	const localeLink = useLocaleLink();

	const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
		onClick(event);

		if (!isFullyAuthenticated) {
			event.preventDefault();
			router.push(localeLink(`${RE_AUTH_ROUTE}?redirect=${encodeURIComponent(href.toString())}`));
		}
	};

	return <Link href={href} {...props} onClick={handleClick} />;
}
